import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useModalInteraction } from '../hooks/useModalInteraction';
const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-xl',
};
export function Dialog({ isOpen, onClose, children, maxWidth = 'md', stickyHeader, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, }) {
    const generatedLabelId = useId();
    const dialogRef = useRef(null);
    const labelledby = ariaLabelledby ?? (!ariaLabel ? generatedLabelId : undefined);
    useModalInteraction({
        enabled: isOpen,
        modalRef: dialogRef,
        onEscape: onClose,
    });
    if (!isOpen)
        return null;
    return createPortal(_jsxs("div", { ref: dialogRef, tabIndex: -1, "data-sam-modal-root": "", className: "fixed inset-0 z-dialog-backdrop flex items-center justify-center p-4", role: "dialog", "aria-modal": "true", "aria-label": ariaLabel, "aria-labelledby": labelledby, "aria-describedby": ariaDescribedby, children: [!ariaLabel && !ariaLabelledby && _jsx("span", { id: generatedLabelId, className: "sr-only", children: "Dialog" }), _jsx("div", { className: "fixed inset-0 bg-overlay glass-backdrop-dim transition-opacity duration-150 ease-in-out", onClick: onClose }), _jsxs("div", { className: `glass-panel-container glass-composited relative w-full max-h-[calc(100dvh-2rem)] flex flex-col rounded-lg glass-modal shadow-overlay ${maxWidthClasses[maxWidth]}`, children: [stickyHeader && (_jsx("div", { className: "flex-shrink-0", children: stickyHeader })), _jsx("div", { className: "overflow-y-auto p-6 flex-1", children: children })] })] }), document.body);
}
//# sourceMappingURL=Dialog.js.map